var map = {
	"./RiderHub.png": 246,
	"./RiderSOSDelivery.jpg": 566,
	"./SergioFoodBurger.png": 477,
	"./juegoweb.jpg": 431,
	"./logo.jpg": 146,
	"./tarotweb.jpg": 821,
	"./webmarcial.jpg": 138,
	"./yo.jpg": 693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 499;